export default "__VITE_ASSET__Bk$qhAMW__"